import { render, staticRenderFns } from "./VolLaluLintasSection.vue?vue&type=template&id=690ad004&scoped=true"
import script from "./VolLaluLintasSection.vue?vue&type=script&lang=js"
export * from "./VolLaluLintasSection.vue?vue&type=script&lang=js"
import style0 from "./VolLaluLintasSection.vue?vue&type=style&index=0&id=690ad004&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690ad004",
  null
  
)

export default component.exports